import { render, staticRenderFns } from "./SettingDoctorSay.vue?vue&type=template&id=1d37a30c&scoped=true&"
import script from "./SettingDoctorSay.vue?vue&type=script&lang=js&"
export * from "./SettingDoctorSay.vue?vue&type=script&lang=js&"
import style0 from "./SettingDoctorSay.vue?vue&type=style&index=0&id=1d37a30c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d37a30c",
  null
  
)

export default component.exports